import type { FC } from "react"

import ChartedHealth_logo from "images/ChartedHealth/logo.webp"

const PatientPortalHeader: FC<Props> = ({
  logoUrl,
  patientPortalUrl,
  headerText,
  shouldWrapHeaderText = true,
  shouldShowPatientPortalLink = true,
}) => (
  <header className="flex flex-col items-center gap-7 md:!gap-9 mb-2 text-center mt-9 md:mt-[5.875rem]">
    <img
      src={logoUrl || ChartedHealth_logo}
      alt="Practice logo"
      className="max-h-[4.125rem] max-w-[8.3125rem] md:!max-h-[4.5625rem] md:!max-w-[9.375rem] object-cover"
    />
    <h1 className="text-[2rem] leading-[2.125rem] md:!text-[2.5rem] md:!leading-[3.5rem] text-primary font-semibold">
      {shouldWrapHeaderText && !headerText ? (
        <>
          <span className="block md:inline">Welcome to</span>
          <span className="block md:inline"> Patient Portal</span>
        </>
      ) : (
        headerText
      )}
    </h1>
    {shouldShowPatientPortalLink && patientPortalUrl && (
      <p className="text-sm text-gray-500">
        Already have an account?{" "}
        <a href={patientPortalUrl} className="ml-5 text-primary font-medium hover:underline">
          Login here
        </a>
      </p>
    )}
  </header>
)

type Props = {
  logoUrl?: string
  patientPortalUrl?: string
  headerText?: string
  shouldWrapHeaderText?: boolean
  shouldShowPatientPortalLink?: boolean
}

export { PatientPortalHeader }
